import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, str2arr} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {StatKindVO, TermPageVO, useQueryStatKinds, useQueryTermPage} from "@/service/term.s";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import {Box, Card, CardContent, Typography, Grid} from "@mui/material";
import {LocalOfferOutlined, VerticalSplitOutlined, EmergencyOutlined, FactCheckOutlined} from '@mui/icons-material';
import {WriteTerm} from "@/pages/Term/WriteTerm";
import {ViewTerm} from "@/pages/Term/ViewTerm";
import {TagOut} from "@/widget/TagOut/TagOut";
import {useMemo} from "react";
import {reduce} from "lodash";

const icons = [<LocalOfferOutlined fontSize={'large'} color={'primary'}/>, <VerticalSplitOutlined fontSize={'large'} color={'success'}/>,
    <EmergencyOutlined fontSize={'large'} color={'warning'}/>, <FactCheckOutlined fontSize={'large'} color={'error'}/>]

export const TermListPage = () => {
    const {
        mutate: termPageMutate,
        data: termPageData,
        isPending: termPagePending,
    } = useQueryTermPage()
    const [selectedCard, setSelectedCard] = React.useState(0);
    const {data: statKindsData} = useQueryStatKinds()
    const statKinds = statKindsData?.data

    const statKind = useMemo(() => {
        if (statKinds) {
            const newStatKinds: StatKindVO[] = Array.from(statKinds)
            const totalKind = reduce(newStatKinds, (prev: StatKindVO, next: StatKindVO): StatKindVO => {
                const totalKind: StatKindVO = prev
                totalKind.amount = prev.amount + next.amount;
                totalKind.maxSubsidy = prev.maxSubsidy + next.maxSubsidy;
                return totalKind;
            }, {amount: 0, maxSubsidy: 0, kind: '全部项目'})
            newStatKinds.unshift(totalKind)

            return newStatKinds?.map((item: StatKindVO, index) => (
                <Grid key={index} size={3}>
                    <Card
                        variant={'outlined'}
                        onClick={() => {
                            setSelectedCard(index)
                            termPageMutate({current: 1, size: 20, kindId: item.kindId!})
                        }}
                        data-active={selectedCard === index ? '' : undefined}
                        sx={{
                            border: 'none',
                            cursor: 'pointer',
                            height: '100%',
                            px: 1.8,
                            py: 1.2,
                            bgcolor: "#f5f6fa",
                            '&[data-active]': {
                                backgroundColor: '#00a1ff1c',
                                '&:hover': {
                                    backgroundColor: 'action.selectedHover',
                                },
                            },
                        }}
                    >
                        <CardContent sx={{height: '100%',}}>
                            <Stack direction={'row'} justifyContent={'space-between'}>
                                <Stack direction={'column'} justifyContent={'space-between'}>
                                    <Typography variant="h6" fontWeight={500} component="div">
                                        {item.kind}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {item.amount}项
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        单项最高奖励{item.maxSubsidy / 10000}万
                                    </Typography>
                                </Stack>
                                <Box>
                                    {icons[index]}
                                </Box>
                            </Stack>

                        </CardContent>
                    </Card>
                </Grid>
            ))
        }
        return []
    }, [statKinds, selectedCard]);

    const columns: GridColDef<TermPageVO>[] = [
        {field: "category", headerName: "政策名称", flex: 0.9},
        {
            field: "kind",
            headerName: "种类",
            flex: 0.8,
            align: 'center',
            headerAlign: 'center',
            renderCell: ({row}) => <Chip variant={'outlined'} label={row.kind} color={'warning'}/>
        },
        {
            field: "maxSubsidy",
            headerName: "最高奖励",
            headerAlign: "center",
            align: "center",
            valueFormatter: value => `${value / 10000}万元`
        },
        {
            field: "startDate",
            headerName: "申报时间",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 190,
            renderCell: ({row}) => `${formatTime("D", row.startDate)}至${formatTime("D", row.endDate)}`,
        },
        {
            field: "level",
            headerName: "级别",
            flex: 0.6,
            align: 'center',
            headerAlign: 'center',
            renderCell: ({row}) => <Chip variant={'filled'} label={row.level} color={'info'}/>
        },
        {
            field: "section",
            headerName: "受理部门",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "subsidies",
            headerName: "补贴类型",
            headerAlign: "center",
            align: "center",
            flex: 1,
            display: "flex",
            renderCell: ({row: {subsidies}}) => {
                const values = str2arr(subsidies, 'str')
                return values?.map((item: string, index: number) => <TagOut sx={{mr: 1}} key={index} index={index} label={item}/>)
            }
        },
    ];

    const TabCard = () => {
        return <Grid p={1} spacing={2} justifyContent={'space-between'} container={true}>{statKind}</Grid>
    }

    return <ProTable<TermPageVO>
        loading={termPagePending}
        renderDrawer={{view: <ViewTerm/>, write: <WriteTerm/>}}
        columns={columns}
        tabs={<TabCard/>}
        drawerProps={{
            view: {
                hiddenFooter: true,
            }
        }}
        data={termPageData?.data}
        onSearch={(params) => {
            termPageMutate({...params, kindId: selectedCard});
        }}
        code={"term"}
    />

};
